import { render, staticRenderFns } from "./UserCardName.vue?vue&type=template&id=4243afb8&scoped=true"
import script from "./UserCardName.vue?vue&type=script&lang=ts"
export * from "./UserCardName.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4243afb8",
  null
  
)

export default component.exports